import * as React from "react";

interface Props {
  style?: React.CSSProperties;
  className?: string;
}
export const SecretIcon: React.FC<Props> = ({ style = {}, className = "" }) => {
  return (
    <svg
      style={style}
      className={className}
      id="Layer_1"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m357 7.849v87.151h65z" />
      <path d="m497 77h-45v93h60v-78c0-8.284-6.716-15-15-15z" />
      <path d="m191.098 141.909 25.538 28.091h205.364v-45h-80c-8.284 0-15-6.716-15-15v-110h-222c-8.284 0-15 6.716-15 15v122h90c4.226 0 8.255 1.783 11.098 4.909z" />
      <path d="m60 77h-45c-8.284 0-15 6.716-15 15v45h60z" />
      <path d="m185.757 295.256c-1.778-46.719-68.752-46.684-70.513 0v10.329h70.513z" />
      <path d="m497 200h-287c-4.226 0-8.255-1.783-11.098-4.909l-25.538-28.091h-158.364c-8.284 0-15 6.716-15 15v315c0 8.284 6.716 15 15 15h482c8.284 0 15-6.716 15-15v-282c0-8.284-6.716-15-15-15zm-211 162h120c19.881.738 19.866 29.269 0 30h-120c-19.881-.738-19.866-29.269 0-30zm-51.75 75.179c0 8.284-6.716 15-15 15h-137.5c-8.284 0-15-6.716-15-15v-116.594c0-8.284 6.716-15 15-15h3.494v-10.329c3.291-86.474 127.253-86.408 130.513 0v10.329h3.493c8.284 0 15 6.716 15 15zm202.752 14.821h-151.002c-19.881-.738-19.866-29.269 0-30h151.002c19.881.738 19.866 29.269 0 30z" />
      <path d="m96.75 422.179h107.5v-86.594h-107.5zm38.75-56.297c.738-19.881 29.269-19.866 30 0v26c-.738 19.881-29.269 19.866-30 0z" />
    </svg>
  );
};
